export default __webpack_public_path__ + "static/media/receipt-pos.8a9bf43e.webp";